import React from 'react';

const BarraVisualizer = ({ largoTotal, piezas, largoBarra }) => {
  const scale = largoBarra / 100; // Escala para visualización (100% del ancho)
  
  const styles = {
    barraContainer: {
      marginBottom: '8px',
      width: '100%',
    },
    barra: {
      height: '24px',
      border: '1px solid #dee2e6',
      position: 'relative',
      marginBottom: '4px',
      borderRadius: '2px',
      overflow: 'hidden',
    },
    pieza: {
      height: '100%',
      position: 'absolute',
      backgroundColor: '#f8f9fa',
      border: '1px solid #dee2e6',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      fontSize: '0.875rem',
      color: '#212529',
    },
    desperdicio: {
      height: '100%',
      position: 'absolute',
      backgroundColor: 'rgba(255, 0, 0, 0.1)',
      border: '1px solid rgba(255, 0, 0, 0.3)',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      fontSize: '0.875rem',
      color: '#dc3545',
    },
    label: {
      fontSize: '0.875rem',
      color: '#212529',
      marginBottom: '2px',
    }
  };

  const renderBarra = (piezasEnBarra, index) => {
    let posicionActual = 0;
    return (
      <div key={index} style={styles.barraContainer}>
        <div style={styles.label}>Perfil {index + 1} (6 metros)</div>
        <div style={styles.barra}>
          {piezasEnBarra.map((pieza, i) => {
            const width = (pieza / scale) + '%';
            const left = (posicionActual / scale) + '%';
            posicionActual += pieza;
            
            return (
              <div
                key={i}
                style={{
                  ...styles.pieza,
                  width,
                  left,
                }}
                title={`${pieza}mm`}
              >
                {pieza}mm
              </div>
            );
          })}
          
          {/* Desperdicio */}
          {posicionActual < largoBarra && (
            <div
              style={{
                ...styles.desperdicio,
                width: ((largoBarra - posicionActual) / scale) + '%',
                left: (posicionActual / scale) + '%',
              }}
              title={`${largoBarra - posicionActual}mm`}
            >
              {largoBarra - posicionActual}mm
            </div>
          )}
        </div>
      </div>
    );
  };

  // Distribuir las piezas en barras
  const distribuirPiezas = () => {
    const barras = [];
    let barraActual = [];
    let espacioDisponible = largoBarra;

    piezas.forEach(pieza => {
      if (pieza <= espacioDisponible) {
        barraActual.push(pieza);
        espacioDisponible -= pieza;
      } else {
        if (barraActual.length > 0) {
          barras.push(barraActual);
        }
        barraActual = [pieza];
        espacioDisponible = largoBarra - pieza;
      }
    });

    if (barraActual.length > 0) {
      barras.push(barraActual);
    }

    return barras;
  };

  const barras = distribuirPiezas();

  return (
    <div style={{ marginTop: '10px' }}>
      {barras.map((piezasEnBarra, index) => renderBarra(piezasEnBarra, index))}
    </div>
  );
};

export default BarraVisualizer; 